export const LIST_BRANCH_SERVICE_CATEGORY_REQUEST =
  'LIST_BRANCH_SERVICE_CATEGORY_REQUEST'
export const LIST_BRANCH_SERVICE_CATEGORY_SUCCESS =
  'LIST_BRANCH_SERVICE_CATEGORY_SUCCESS'
export const LIST_BRANCH_SERVICE_CATEGORY_FAIL =
  'LIST_BRANCH_SERVICE_CATEGORY_FAIL'

export const PATCH_BRANCH_SERVICE_CATEGORY_REQUEST =
  'PATCH_BRANCH_SERVICE_CATEGORY_REQUEST'
export const PATCH_BRANCH_SERVICE_CATEGORY_SUCCESS =
  'PATCH_BRANCH_SERVICE_CATEGORY_SUCCESS'
export const PATCH_BRANCH_SERVICE_CATEGORY_FAIL =
  'PATCH_BRANCH_SERVICE_CATEGORY_FAIL'

export const DETAIL_BRANCH_SERVICE_CATEGORY_REQUEST =
  'DETAIL_BRANCH_SERVICE_CATEGORY_REQUEST'
export const DETAIL_BRANCH_SERVICE_CATEGORY_SUCCESS =
  'DETAIL_BRANCH_SERVICE_CATEGORY_SUCCESS'
export const DETAIL_BRANCH_SERVICE_CATEGORY_FAIL =
  'DETAIL_BRANCH_SERVICE_CATEGORY_FAIL'
